import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { readConsentCookie } from '@ecom/common';

@Injectable({
  providedIn: 'root',
})
export class PrivacyCheckService {
  constructor(@Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId: object) {}

  /**
   * a function to check if user has global privacy control .
   * @returns void.
   */
  public updatePrivacyCheck(doNotSell: number): void {
    if (!isPlatformBrowser(this.platformId)) {
      return; // Exit early if not in browser
    }

    try {
      const date = new Date();
      const expiresDate = new Date(date.setDate(date.getDate() + 3700));
      const expiresDateString = expiresDate.toUTCString();

      const hostname = this.getHostname();
      if (hostname) {
        this.document.cookie = `consent-ad-personalization=${doNotSell}; expires=${expiresDateString}; path=/; domain=${hostname}`;
      }
    } catch (error) {
      // Silently handle error - privacy cookie setting is not critical
      return;
    }
  }

  public getPrivacyCookie(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null; // Return null if not in browser
    }

    try {
      // Shared parser: an empty or unrecognized value is returned as-is, so the opt-out fails closed.
      return readConsentCookie(this.document.cookie);
    } catch (error) {
      // Silently handle error and return null
      return null;
    }
  }

  /**
   * Safely get hostname from window.location
   * @returns hostname or null if not available
   */
  private getHostname(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    try {
      if (typeof window !== 'undefined' && window.location && window.location.hostname) {
        return window.location.hostname.split('.').slice(-2).join('.');
      }
      return null;
    } catch (error) {
      // Silently handle error
      return null;
    }
  }
}
